<template>
  <div class="list-container">

    <no-ssr>
<!--      <div ref="TopUpListBar">-->
<!--        <TopUpListBar-->
<!--          @closeBar="closeBar"-->
<!--        />-->
<!--      </div>-->

    </no-ssr>

    <div class="main-wrap">

      <TupianBreadcrumbs :breadcrumbs="crumbList"/>
      <MenuNav
        :params="params"
        :materialNum="materialNum"
        :self_list="self_list.slice(0)"
        :category_list="category_list"
        :other_list="other_list.slice(0)"
        :scene_list="scene_list"
        :usageTypeList="usageTypeList"
        :menuList="menuList"
        :typeList="typeList"
        :styleClassify="styleClassify"
      />

      <div class="inner_center ">

        <div
          class="material-box _inner_content"
        >
          <div class="headline overflow-one">
            <h1> {{ searchKeyword }}</h1>
            <span class="subhead">图片结果</span>
          </div>
          <div>

            <template v-if="materialList.length > 0">
              <PicList
                :pic-list="materialList"
                :isShowPicTitle="true"
              />
            </template>

            <div
              v-else
              class="no-data-box inner_center">

              <div class="no-data-img"/>
              <div class="no-data-info">
                <template v-if="reqState && isForbid">
                  <div class="title">
                    <i class="icon_forbid"/>
                    根据相关法律法规和政策，搜索无结果
                  </div>
                </template>
                <template v-if="reqState && !isForbid">
                  <div class="title">抱歉，没有找到符合条件的素材</div>
                  <div class="no-data-text">您可以尝试：
                    <span> • 检查拼写 • 使用同义词或通用术语</span>
                    <!--                  或者也可以向-->
                  </div>
                  <div
                    @click="navTo"
                    class="text-fankui">提交素材建议
                  </div>
                </template>
              </div>

            </div>
          </div>
        </div>

        <div class="recommend-words" v-if="tupianListRecommendWord.length">
          <span>相关搜索词：</span>
          <a
            v-for="vo in tupianListRecommendWord"
            :href=" PAGE_PATH.BASE_URL + PAGE_PATH.TUPIAN_LIST + '/' + vo.pinyin + '.html' "
            :title="vo.word"
            target="_blank"
          >
            {{ vo.word }}</a>
        </div>
        <div class="pagination-box">
          <!--          <CtPagination
                      v-if="totalPage > 1"
                      class="CtPagination"
                      :total-page="totalPage"
                      :paper-count="5"
                      :current-page="params.page"
                      @pageClick="handleCurrentChange"
                    />-->

          <PublicPagination
            v-if="totalPage > 1"
            class="CtPagination"
            :total-page="totalPage"
            :paper-count="5"
            :current-page="params.page"
            :aLinkLeft="aLinkLeft"
            :aLinkRight="aLinkRight"
            @pageClick="handleCurrentChange"
          />
        </div>


<!--                  v-show="topicList.length && isLogin"
-->
        <CollectionRecommend
          id="CollectionRecommend"
          v-show="topicList.length "
          class="CollectionRecommend" :pic-list="topicList"
          title="更多精选推荐"
          topicTitle="更多精选推荐"
          @picItemTopicClick="picItemTopicClick"
          @topicMouseover="topicMouseover"
        ></CollectionRecommend>


        <div class="recommend-text">
          潮国创意专注于创作高质量素材模板网站，您在这里可以找到：{{ searchKeyword }}图片、{{ searchKeyword }}海报模板、{{
            searchKeyword
          }}专题、{{ searchKeyword }}banner等高清图片素材，同时潮国创意还为新用户提供了{{ searchKeyword }}专题模板免费下载服务。
        </div>

      </div>
    </div>
    <!-- 续费通知 -->


    <template v-if="!spider">
      <VipRenewalNotice/>
      <ModalCollect/>
<!--      <NoLoginBar/>-->
<!--      <ActGuoQingBuoy/>-->
      <!--      <WebsiteRatingModel/>-->
    </template>

    <no-ssr>
<!--      <ActLoginCouponBar />-->
      <ActSlot />

    </no-ssr>

  </div>
</template>

<script>
import {
  categoryList,
  menuList,
  ObjectToArray,
  parseListUrl,
  parseUrlStr,
  timeList,
  usageTypeList,
  typeList
} from "@/components/list/module";

import ModalCollect from '@/components/modal/collect'
import {MaterialList} from "@/components/material/index.js"
import {BackToTop, CtPagination, PublicHeader} from "@/components/common/index.js"
import MenuNav from "@/components/list/menu-nav";
import {getMaterialClassify, getMaterialList, getTupianListMoreTopic} from "@/api/material";
import {MATERIAL_LIST_PATH} from "@/constant/PATH";
import {mapGetters, mapMutations, mapState} from "vuex";
import inviteCombobox from '@/components/act/invite/invite-combobox'
import {PIC_TOTAL_NUM} from "@/constant/MATERIALS";
import {TopUpListBar} from "@/components/act/top-up";
import {sceneList} from "@/components/home/common/module";
import {
  fnBrowser,
  fnCollection,
  fnFlowStatistics,
  fnLogin,
  fnMaterial,
  fnRouter,
  fnTopic,
  fnTuPian,
  fnUser
} from "@/fn";
import LoginGuide from "@/components/modal/login-guide/login-guide";
import VipRenewalNotice from "@/components/common/notice/vip-renewal"
import PicList from '@/components/pic/pic-list/pic-list';
import {listGetNextDate, listObjToArray, setListType} from "@/components/tupian/common/list";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import TupianClassify from '@/components/tupian/tupian-classify'
import TupianBreadcrumbs from '@/components/tupian/tupian-breadcrumbs'
import CollectionRecommend from '@/components/collection/collection-recommend';
import NoLoginBar from '@/components/common/login/no-login-bar'
import {TOPIC} from "@/constant/tupian/TOPIC";
import mixin from '@/pages/tupian/common/mixin'
import * as fnCommon from "@/fn/_fn";
import ActGuoQingBuoy from "@/components/act/guoqing/ActGuoQingBuoy";

import PublicPagination from '@/components/_Public/Pagination'
// import ActLoginCouponBar from '@/components/_Privately/Act/ActLoginCouponBar'
import ActSlot from '@/components/_Privately/Act/ActSlot'
import {DEMAND_POOL} from "@/constant/_Public/Path";


export default {
  name: "MaterialDetails",
  layout: "header-nav",
  mixins: [mixin],
  components: {
    MaterialList,
    PublicHeader,
    BackToTop,
    inviteCombobox,
    CtPagination,
    TopUpListBar,
    MenuNav,
    LoginGuide,
    VipRenewalNotice,
    PicList,
    ModalCollect,
    TupianClassify,
    TupianBreadcrumbs,
    CollectionRecommend,
    NoLoginBar,
    ActGuoQingBuoy,
    PublicPagination,
    // ActLoginCouponBar,
    ActSlot
  },
  computed: {
    ...mapGetters('layout', ['screenWidth', 'bannerHeight']),
    ...mapState('user', ['companyVipState', '']),
    ...mapState('base', ['spider', '']),
    isShowListBar() {
      return this.$store.state.base.isShowListBar
    },
    isShowCaseCollectionBar() {
      return this.$store.state.base.isShowCaseCollectionBar
    },
    isLogin() {
      return this.$store.state.user.isLogin
    }
  },
  watch: {
    isShowListBar: {
      handler(n) {
        /*setTimeout(()=>{
          if (this.$refs.HeaderWrap.offsetHeight){
            this.headerHeight = this.$refs.HeaderWrap.offsetHeight
          }

        },500)*/

        if (n == true) {
          // this.headerHeight = 61 + 56;
          this.listenHeaderWrapHeight();
        } else {
          // this.headerHeight = 61;
          this.headerHeight = 0
        }
      },
      immediate: true

    },
    isShowCaseCollectionBar: {
      handler(n) {
        /*setTimeout(()=>{
          if (this.$refs.HeaderWrap.offsetHeight){
            this.headerHeight = this.$refs.HeaderWrap.offsetHeight
          }

        },500)*/

        if (n == true) {
          // this.headerHeight = 61 + 56;
          this.listenHeaderWrapHeight();
        } else {
          // this.headerHeight = 61;
          this.headerHeight = 0
        }
      },
      immediate: true
    },
    companyVipState: {
      handler(n) {
        if (n == true) {
          // this.headerHeight = 61 + 56;
          this.listenHeaderWrapHeight();
        } else {
          // this.headerHeight = 61;
          this.headerHeight = 0
        }
      },
      immediate: true

    },
    isSpider: {
      handler(n, o) {
        if (n == true || n == false) {
          this.$store.commit('base/SET_SPIDER', n)
        }
      },
      immediate: true
    },

    searchKeyword: {
      handler(n, o) {
        this.$store.commit('base/SET_SEARCH_VAL', '')
        if (n) {
          this.$store.commit('base/SET_SEARCH_VAL', n)
        }
      },
      immediate: true
    },

    isLogin(n, o) {
      let id = this.$route.params.id;
      let tempParams = parseListUrl(this.$route.path, id)
      if (n || n == true || n == false) {
        // this.getMaterialList(tempParams)
        this.initFooter();
      }
    },
  },

  head() {
    return {
      title: this.tkd.title,
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.tkd.keywords
        },
        {
          hid: 'description',
          name: 'description',
          content: this.tkd.description
        },
        {
          property: 'article:published_time',
          content: this.published_time
        },
      ]
    }
  },
  data() {
    return {
      sceneList,
      categoryList, // 分类列表
      categoryIndex: 0,
      isShowCategoryList: false,
      // menuList, // 导航列表
      menuIndex: 0,
      timeList,
      timeIndex: 0,
      timeText: "全部时间",
      isShowTimeList: false,
      // usageTypeList,
      usageTypeText: "适用类型",
      isShowUsageTypeList: false,
      usageTypeIndex: 0,
      creenWidth: 0,
      compare1400: true,
      headerHeight: 56,
      showCategoryList: true,

      params: {
        pinyin: 0,
        home_keyword_id: 0,
        layout: 0,
        time_filter: 0,
        category: 0,
        module: 0,
        desc: "default",
        page: 1,
        scene: 0
      },
      materialList: [],
      searchKeyword: "",
      totalPage: 0,
      detail: {},
      reqState: false,
      PIC_TOTAL_NUM,
      tkd: {
        'title': '潮国创意_中国原创潮流_创意图片设计_正版商用版权素材库',
        'keywords': '潮国创意,中国元素,中国元素素材,潮流创意,创意设计,创意设计网站,原创设计,图片素材,潮流图片,潮流设计,设计图,创意作品',
        'description': '潮国创意是目前国内为设计师、创意机构和创作人员寻找高质量、吸睛创意设计资源的素材图片网站。包含各类潮流前沿、高品质正版原创图片素材，chaopx.com 是值得信懒、可商用的潮流设计网站。'
      },
      nCategoryIndex: 0,
      nSceneIndex: 0,
      isForbid: false,
      isSpider: false,
      searchRecommendWordList: [],
      tupianListRecommendWord: [],
      published_time: '',
      MATERIAL_LIST_PATH,

      /* 分类 */
      self_list: [],  // 当前分类
      other_list: [], // 全部分类去除当前分类
      category_list: [], // 二级分类
      scene_list: [], // 二级分类
      crumbList: [], // 二级分类
      usageTypeList: [],
      menuList: [],
      styleClassify: [],
      materialNum: '',

      layoutName: '格式',
      typeList,
      topicList: [],
      PAGE_PATH,
      aLinkLeft:'',
      aLinkRight:''
    }
  },

  async asyncData({app, req}) {

    let UA = app.context.req.headers['user-agent']
    let tempParams = fnTuPian.parseUrl(app)

    if (tempParams.home_keyword_id == 999) {
      tempParams.real_home_keyword_id = 999;
      tempParams.home_keyword_id = 0;
    } else {
      tempParams.real_home_keyword_id = -1;
    }
    let [
      tupianClassify,
      // materialList,
      styleClassify
    ] = await Promise.all([
      app.$api.getMaterialClassify({
        'home_keyword_id': tempParams.home_keyword_id,
        'module': tempParams.module,
      }),
      // app.$api.getMaterialList(tempParams),
      app.$api.getMaterialStyleClassify(),
    ])

    /* 区分 分类和设计风格 */
    let materialList = [];
    if (parseInt(tempParams.categoryType) === 0) {
      tempParams.design = 0;
    } else {
      tempParams.category = 0;
    }
    materialList = await app.$api.getMaterialList(tempParams)


    let tupianListRecommendWord = await app.$api.getTupianListRecommendWord({keyword: materialList.keyword})
    let topicList = await app.$api.getTupianListMoreTopic({
      'category': tempParams.home_keyword_id,
      'keyword': materialList.keyword,
    })

    let {list, keyword, is_forbid, total_page, module, tkd, scene, search_recommend} = materialList;
    let classifyInfo = fnTuPian.disposeClassify(tupianClassify, tempParams, styleClassify.data)
    let {self_list, other_list, category_list, scene_list, usageTypeList, menuList, style_list} = classifyInfo
    // setTimeout(()=>{
    let crumbList = fnTuPian.findCrumbList(tempParams, self_list, scene_list, category_list, keyword, styleClassify.data)
    // },2000)


    /* a链接拼接 */
    let aLinkLeft = '', aLinkRight = '';


    if (tempParams) {
      let {
        pinyin,
        home_keyword_id,
        layout,
        time_filter,
        module,
        category,
        scene,
        page,
        desc,
        categoryType,
        design,
        layer
      } = tempParams;

      aLinkLeft = `/tupian/${pinyin}-${home_keyword_id}-${layout}-${time_filter}-${module}-${category}-${scene}-${desc}-`;
      aLinkRight = `-${layer}-${design}-${categoryType}.html`;

    }


    console.log()

    return {
      materialList: setListType(listObjToArray(list)),
      searchKeyword: !is_forbid ? keyword : '',
      totalPage: total_page,
      isForbid: is_forbid,
      reqState: true,
      tkd: tkd,
      isSpider: fnBrowser.isSpider(UA),
      searchRecommendWordList: search_recommend,
      published_time: listGetNextDate(),
      // time: timeObj
      self_list,  // 当前分类
      other_list, // 全部分类去除当前分类
      category_list, // 二级分类
      scene_list, // 二级分类
      crumbList,
      usageTypeList,
      menuList,
      tupianListRecommendWord: tupianListRecommendWord.data == null ? [] : tupianListRecommendWord.data,
      topicList: fnCollection.disposeRecommendList(topicList.data),
      styleClassify: style_list,
      aLinkLeft,
      aLinkRight
    }
  },
  created() {
    // this.SET_IS_SHOW_SEARCH(true)
    let id = this.$route.params.id;
    let routerPath = this.$route.path;
    this.params = parseListUrl(routerPath, id)
  },
  mounted() {

    // this.headerHeight = this.$refs.listHeader.offsetHeight;

    /* eslint-disable */

    if (process.client) {
      let tempScreenWidth = document.body.clientWidth;
      this.compare1400 = tempScreenWidth > 1440;

      const that = this
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.compare1400 = window.screenWidth > 1440;
        })()
      }
    }
    this.init();
    this.initMaterialNum();
    this.initFooter();


    /* 测试代码 */
    // this.getTopicList();
  },
  methods: {
    ...mapMutations('layout', ['SET_IS_SHOW_SEARCH']),

    async initMaterialNum() {
      this.materialNum = await fnMaterial.getMaterialNum() + '+';
    },


    listenHeaderWrapHeight() {
      if (this.$refs.HeaderWrap) {
        this.$nextTick(() => {
          this.headerHeight = this.$refs.HeaderWrap.offsetHeight
        })
      }
    },

    closeBar() {
      this.headerHeight = 0
    },

    init() {
      this.listenHeaderWrapHeight();
      this.listenStatistics()
      let id = this.$route.params.id;
      let tempParams = parseListUrl(this.$route.path, id)
      // this.getMaterialList(tempParams)
      fnTuPian.keywordTrack(this.searchKesyword);
      this.initFooter();
      this.topicPositionStat();
    },

    initFooter() {
      if (this.spider) {
        return false
      }
      /*if (!fnLogin.checkLogin()) {
        document.getElementById('FooterWrap').style.display = 'none';
      } else {
        document.getElementById('FooterWrap').style.display = 'block';
      }*/
    },

    topicPositionStat() {
      if (this.topicList.length) {
        let ids = this.topicList.map(item => item.id)
        console.log(ids)

        fnTopic.positionStat(
          ids.toString(),
          TOPIC.POSITION_STAT.EVENT.EXPOSE,
          TOPIC.POSITION_STAT.POSITION.TUPIAN_BOTTOM,
        )

      }
    },

    /* 流量入口监听 */
    listenStatistics() {
      let id = this.$route.params.id;
      let routerPath = this.$route.path;
      let tempParams = parseListUrl(routerPath, id);
      let {home_keyword_id} = tempParams
      if (home_keyword_id == 0) {
        fnFlowStatistics.pageFlow('hot')
      } else if (home_keyword_id == 2) {
        fnFlowStatistics.pageFlow('festival')
      } else if (home_keyword_id == 3) {
        fnFlowStatistics.pageFlow('solarTerms')
      } else if (home_keyword_id == 4) {
        fnFlowStatistics.pageFlow('3D')
      }
    },


    getIdParams() {
      let id = this.$route.params.id;
      return parseUrlStr(id);
    },

    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      console.log(scrollTop)
      this.showCategoryList = scrollTop < 1000
    },

    /*initIsShowCategoryList() {
      let isShowCategoryList = this.$localStorage.getItem('IsShowCategoryList');
      console.log(isShowCategoryList)
      if (!!isShowCategoryList) {
        this.isShowCategoryList = isShowCategoryList;
      }
    },

    toggleIsShowCategoryList() {
      console.log(this.isShowCategoryList)
      this.isShowCategoryList = !this.isShowCategoryList;
      this.$localStorage.setItem('IsShowCategoryList', this.isShowCategoryList)
    },
*/

    getMaterialList(tempParams) {
      this.reqState = false
      getMaterialList(tempParams).then(res => {
        let {list, keyword, is_forbid, total_page, module, tkd, scene} = res.data;
        this.$store.commit('base/SET_SEARCH_VAL', is_forbid ? '    ' : keyword)
        this.searchKeyword = !is_forbid ? keyword : '';
        this.totalPage = total_page;
        this.isForbid = is_forbid
        this.materialList = setListType(listObjToArray(list))
        this.reqState = true
        this.tkd = tkd
      })
    },
    handleCurrentChange(val) {
      let id = this.$route.params.id;
      let routerPath = this.$route.path;
      let tempParams = parseListUrl(routerPath, id);
      tempParams.page = val;

      let {pinyin, home_keyword_id, layout, time_filter, module, category, scene, page, desc, layer} = this.params;

      if (tempParams.categoryType == 0) {
        let path = MATERIAL_LIST_PATH + `/${pinyin}-${home_keyword_id}-${layout}-${time_filter}-${module}-${category}-${scene}-${desc}-${val}-${layer}.html`;
        fnRouter.navigationTo(path, '_self');
      } else {
        let path = MATERIAL_LIST_PATH + `/${pinyin}-${home_keyword_id}-${layout}-${time_filter}-${module}-${category}-${scene}-${desc}-${val}-${layer}-${tempParams.design}-1.html`;
        fnRouter.navigationTo(path, '_self');
      }
    },

    navTo() {
      // fnRouter.navigationTo(PAGE_PATH.FEEDBACK)
      fnRouter.navigationTo(DEMAND_POOL)
    },

    /* 测试接口 */
    async getTopicList() {
      let tempParams = parseListUrl(this.$route.path, this.id)

      getTupianListMoreTopic({
          'category': tempParams.home_keyword_id,
          'keyword': this.materialList.keyword,
        }
      ).then(res => {
        console.log(res)
        this.topicList = fnCollection.disposeRecommendList(res.data.data)
      })
    },

    picItemTopicClick(topicId) {
      fnTopic.positionStat(
        topicId,
        TOPIC.POSITION_STAT.EVENT.CLICK,
        TOPIC.POSITION_STAT.POSITION.TUPIAN_BOTTOM,
      )
    },

    topicMouseover(topicId) {
      fnTopic.positionStatMouseOver(
        topicId, TOPIC.POSITION_STAT.POSITION.TUPIAN_BOTTOM,
      )
    },
  },

  filters: {
    usageTypeListName(val) {
      let findOne = usageTypeList.find(vo => vo.id == val);
      if (findOne > -1) {
        return findOne.title;
      } else {
        return '格式';
      }
    },
    timeFilterName(val) {
      let findOne = timeList.find(vo => vo.id == val);
      return findOne.title;
    },

    layoutName(val) {

    }
  }
}
</script>


<style lang="scss" scoped>
@import "@/components/common/header/layout-header.scss";
@import "@/components/common/pages/pages.scss";

[v-cloak] {
  display: none;
}


.list-container {
  .inner-content {
    display: flex;
    height: 100%;
    position: relative;

    .CtPagination {
      &.ct-pagination {
        margin: 44px 0 80px !important;
      }
    }

    .inner-left {
      width: 146px;
      transition: all 0.5s ease-in-out;
    }
  }

  .header-wrap {
    //border-bottom: 1px solid #ECEFF6;
    //height: 60px;
    background: #FFFFFF;
    position: fixed;
    //position: relative;
    //top: 276px;
    left: 0;
    right: 0;
    z-index: 99;

    .filter-box {
      height: 100%;
      font-size: 16px;
      color: #424866;
      line-height: 22px;
      @include LayoutFlex(1);
      justify-content: flex-start;
      padding-left: 20px;
      box-sizing: border-box;
      position: relative;
      @include ElementHover($color-primary, '') {
        .icon-filter {
          color: $color-primary;
        }
      }
    ;

      .icon-filter {
        font-size: 20px;
        margin-right: 7px;
        color: #424866;
      }


    }


    .category-list-wrap {
      position: relative;
    }

  }

  .main-wrap {


    .inner_center {
      position: relative;
    }

    .category-list {
      background-color: #fff;
      margin-top: 17px;
      transition: all 0.5s ease-in;
      position: absolute;
      top: 60px;
      left: 0;
      /*display: flex;
      flex-direction: column;*/
      //background-color: pink;

      &.on {
        left: -9000px;
      }

      &.leave {
        left: 0px;
      }

      .category-item {
        display: block;
        width: 94px;
        height: 36px;
        line-height: 36px;
        box-sizing: border-box;
        padding: 0 20px;
        color: #424866;
        font-size: 14px;
        text-align: center;
        //background-color: #fff;


        @include ElementHover($color-primary, '');

        &.on {
          display: inline-block;
          box-sizing: border-box;
          line-height: 36px;
          width: 94px;

          background: $color-primary;
          border-radius: 18px;
          color: #FFFFFF;
          @include ElementHover(#FFFFFF, '');
        }

      }


    }

    //margin-top: 133px;
    min-height: 688px;
    //padding-bottom: 80px;

    /* 素材列表适配 4中 1400伸缩/1200伸缩
       1440 336*440 32 32 1344 + 96 1440
       1440 收缩	294*385 28 28 1176 + 84 1260
       1200 279*365 28 1116 1200
       1200 收缩 241*315 24  964 + 72 1036
     */

    @mixin MaterialItem($width,$height,$marginRight,$marginButtom,$totalWidth,$paddingLeft:0px) {
      /deep/ .com_material-list {
        width: $totalWidth;
        //margin: 0 auto;
        transition: all 0.5s ease-in;
        padding-left: $paddingLeft;

      }
      /deep/ .material-item {
        transition: all 0.5s ease-in;
        width: $width !important;
        height: $height !important;
        margin-right: $marginRight !important;
        margin-bottom: $marginButtom !important;
        box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.06);
        border-radius: 14px;
        position: relative;

        &:nth-child(4n) {
          margin-right: 0 !important;
        }

        a.img-wrap {
          width: 100%;
          height: 100%;

          .img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }


    .material-box {
      position: relative;
      right: 0;
      //padding: 24px 33px 0 0;
      padding: 24px 0 0 0;
      //@include MaterialItem(336px, 440px, 32px, 32px, 1440px);
      transition: all 0.5s ease-in;
      //border-left: 1px solid transparent;


      /* &.on {
         //left: 179px;
         left: 146px;
         //border-left: 1px solid #ECEFF6;
       }*/

      &.lever {
        left: 0;
      }

      .headline {
        //max-width: 586px;
        font-size: 20px;
        font-weight: bold;
        color: #424866;
        line-height: 42px;
        letter-spacing: 2px;
        margin-bottom: 24px;
        display: flex;
        align-items: flex-end;

        .subhead {
          font-size: 12px;
          color: rgba(0, 16, 19, 0.35);
          line-height: 30px;
          margin-left: 8px;
          font-weight: normal;

        }

        .recommend-word {
          span {

          }
        }
      }

      .com_material-list {
        display: flex;
        flex-wrap: wrap;
      }

      .no-data-box {
        //width: 100%;
        text-align: center;
        padding: 118px 0 168px;

        .no-data-img {
          width: 186px;
          height: 198px;
          @include BgImage(186px, 198px, 'material/empty.png');
        }

        .no-data-info {
          //height: 20px;
          font-size: 14px;
          color: rgba(0, 16, 19, 0.65);
          line-height: 20px;

          .title {
            font-size: 18px;
            color: #001013;
            line-height: 24px;
            margin: 32px 0 10px;

            .icon_forbid {
              @include BgImage(24px, 24px, 'tupian/icon_forbid.png');
            }

          }

          .no-data-text {
            color: rgba(0, 16, 19, 0.5);

            span {
              color: rgba(0, 16, 19, 0.65);
            }
          }

          .text-fankui {
            display: inline-block;
            background-color: $color-primary;
            color: #FFFFFF;
            //width: 144px;
            padding: 0 30px;
            border-radius: 8px;
            font-size: 14px;
            line-height: 44px;
            margin-top: 24px;
            cursor: pointer;
          }
        }
      }

    }


    /*@include Screen(1) {
      .material-item {
        width: 336px;
        height: 440px;
        margin: 0 32px 32px 0;
        margin: 0 0px 0px 0;
      }
    }

    @include Screen(2) {
      .material-item {
        width: 279px;
        height: 365px;
        //margin: 0 28px 28px 0;
      }
    }*/


    /*.material-box-1400 {
      @include MaterialItem(336px, 440px, 32px, 32px, 1440px);
      //@include MaterialItem(336px, 440px, 32px, 32px, 1260px);
      .headline {

      }
    }

    .material-box-1400-narrow {
      @include MaterialItem(294px, 395px, 28px, 28px, 1260px, 34px);

      .headline {
        //padding-left: 34px;
      }
    }

    .material-box-1200 {
      @include MaterialItem(279px, 365px, 28px, 28px, 1200px);
    }

    .material-box-1200-narrow {
      @include MaterialItem(241px, 315px, 24px, 24px, 1036px, 24px);

      .headline {
        //padding-left: 24px;
      }
    }*/

  }
}


.header-wrap-placeholder {
  transition: all 0.2s ease-in-out;
}

.recommend-text {
  color: #424866;
  padding-bottom: 20px;
}

.search-recommend-word {
  margin-left: 20px;
  font-size: 14px;
  line-height: 30px;

  span {
    margin-right: 10px;
    @include ElementHover($color-primary, '');
  }
}

.recommend-words {
  display: flex;
  //align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  span {
    display: inline-block;
    line-height: 32px;
  }

  a {
    display: inline-block;
    padding: 0 10px;
    line-height: 30px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    margin: 0 10px 10px 0;
    color: #424866;

    &:hover {
      color: $color-primary;
      border-color: $color-primary;
    }
  }
}

.CollectionRecommend {
  background: #FFFFFF !important;
  padding-top: 0 !important;

  .PicItemRecommend {
    width: 336px;
    height: 440px;
    border-radius: 14px;
    margin: 0 32px 40px 0;
    position: relative;
    transition: all 0.5s ease-in-out;
    display: flex;
    flex-direction: column;
    background: transparent;

    &:nth-child(4n) {
      margin-right: 0;
    }

    .shadow-box {
      content: '';
      display: inline-block;
      width: 100%;
      height: 399px;
      background: #FFFFFF;
      box-shadow: 0px 8px 16px 0px rgba(213, 221, 236, 0.4);
      border-radius: 14px;
      @include Position(1, 4, 0, 0);
      z-index: 1;
    }


    &:hover {
      .pic-img {
        transform: scale(1) !important;
      }

    }

    @include ElementHover('', '') {
      box-shadow: none !important;
    }

    .pic-shadow {
      width: 336px;
      height: 399px;
      background: #FFFFFF;
      box-shadow: 0px 8px 16px 0px rgba(213, 221, 236, 0.4);
      border-radius: 14px;
      @include Position(1, 4, 0, 0);
      z-index: 1;
    }

    .mask1 {
      width: 336px;
      height: 302px;
      background-size: cover;
      @include Position(1, 5, 0, 41px);
      z-index: 2;
      border-radius: 14px;
      overflow: hidden;

      i {
        display: inline-block;
        width: 100%;
        height: 100%;
        overflow: hidden;
        backdrop-filter: blur(20px);
        filter: blur(20px);
        border-radius: 14px 14px 0px 0px;
      }

      &:after {
        content: '';
        display: inline-block;
        width: 100%;
        height: 100%;
        @include Position(1, 5, 0, 0);
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, #FFFFFF 100%);
      }
    }

    .mask2 {
      width: 308px;
      height: 320px;
      background-size: 100% 302px;
      @include Position(1, 5, 50%, 20px);
      transform: translateX(-50%);
      z-index: 3;
      border-radius: 14px;
      overflow: hidden;

      i {
        display: inline-block;
        width: 336px;
        height: 302px;
        overflow: hidden;
        backdrop-filter: blur(100px);
        filter: blur(100px);
        border-radius: 14px 14px 0px 0px;

      }

      &:after {
        content: '';
        display: inline-block;
        width: 100%;
        height: 100%;
        @include Position(1, 5, 0, 0);
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, #FFFFFF 100%);
      }
    }


    .pic-cover {
      @include Position(1, 5, 50%, 0);
      transform: translateX(-50%);
      z-index: 5;
      width: 278px;
      height: 360px;
      border-radius: 14px;
      overflow: hidden;

      .pic-img-wrap {
        display: inline-block;
        width: 100%;
        height: 100%;
        border-radius: 14px;

        .pic-img {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
    }

    .topic-info {
      width: 100%;
      height: 80px;
      @include Position(1, 4, 0, 0);
      z-index: 10;
      box-sizing: border-box;
      padding: 18px 18px 0;

      .topic-title {
        margin-bottom: 4px;
        display: flex;
        align-items: center;

        .title {
          max-width: 152px;

          font-size: 18px;
          font-weight: bold;
          color: #0A2540;
          line-height: 24px;
          letter-spacing: 1px;
        }

        .icon_view {
          @include BgImage(20px, 20px, 'topic/index/icon_yl.png');
          margin-left: 8px;
          position: relative;

          &:after {
            content: '';
            height: 8px;
            background: transparent;
            width: 80px;
            @include Position(1, 5, 0, -3px);
            display: none;
          }

          &:hover {
            &:after {
              display: block;
            }

            .topic-pictures-box {
              display: block;
            }
          }

          .topic-pictures-box {
            width: 384px;
            height: 264px;
            background: #FFFFFF;
            box-shadow: 0px 2px 8px 0px rgba(10, 37, 64, 0.1);
            border-radius: 10px;
            @include Position(1, 5, -4px, -268px);
            z-index: 11;
            padding: 10px 10px 0;
            box-sizing: border-box;
            overflow-y: scroll;
            display: none;

            .topic-pictures {
              display: inline-block;
              width: 88px;
              height: 114px;
              border-radius: 6px;
              overflow: hidden;
              margin: 0 4px 4px 0;

              &:hover {
                img {
                  transform: scale(1.1);
                }
              }

              &:nth-child(4n) {
                margin-right: 0;
              }

              img {
                display: inline-block;
                width: 100%;
                height: 100%;
                transition: all 0.5s ease-in-out;
              }
            }

          }
        }
      }

      .topic-about {
        font-size: 12px;
        color: rgba(10, 37, 64, 0.6);
        line-height: 16px;
      }
    }

    .subscription {
      width: 84px;
      height: 32px;
      border-radius: 24px;
      position: relative;
      z-index: 15;
      @include Position(1, 3, 18px, 27px);
      display: flex;
      align-items: center;
      justify-content: center;


      .txt-subscription {
        font-size: 14px;
        color: #FFFFFF;
      }


      &.subscription-topic {
        background: linear-gradient(44deg, #FE7E7E 0%, #F94D67 100%);
        @include ElementHover('', linear-gradient(44deg, #F94D67 0%, #FE7E7E 100%));

        .icon-sub {
          display: inline-block;
          font-size: 14px;
          color: #FFFFFF;
          margin-right: 6px;
        }

        .txt-subscription {
          font-size: 12px;
          color: #FFFFFF;
          line-height: 16px;
        }

      }

      &.no-subscription-topic {
        background: #FFFFFF;
        border: 1px solid #ECEFF6;

        @include ElementHover('', #F7F9FD);

        &:after {
          background: rgba(66, 72, 102, 0.15);
        }

        .txt-subscription {
          color: #7A7E93;
          font-size: 12px;
        }

        .icon_subscription {
          @include BgImage(14px, 14px, 'topic/index/icon_subscription.svg');
          margin-right: 6px;

        }
      }
    }


    @include Screen(1) {
      width: 279px;
      height: 364px;
      background: #FFFFFF;
      box-shadow: 0px 8px 16px 0px rgba(213, 221, 236, 0.4);
      border-radius: 14px;
      margin: 0 28px 36px 0;


      .shadow-box {
        height: 332px;

      }
      .mask1 {
        width: 279px;
        height: 251px;
      }
      .mask2 {
        width: 255px;
        height: 265px;
      }
      .pic-cover {
        width: 230px;
        height: 296px;
        border-radius: 14px;
      }

      .topic-info {
        height: 69px;
        padding: 13px 16px 0;

        .topic-title {
          .title {
            max-width: 133px;
            font-size: 16px;
            font-weight: bold;
            color: #0A2540;
            line-height: 21px;
            letter-spacing: 1px;
          }
        }

        .icon_view {
          @include BgImage(13px, 13px, 'topic/index/icon_yl.png');
        }
      }

      .subscription {
        width: 80px;
        height: 32px;
        border-radius: 24px;
        position: relative;
        z-index: 15;
        @include Position(1, 3, 16px, 24px);
        display: flex;
        align-items: center;
        justify-content: center;


        .txt-subscription {
          font-size: 14px;
          color: #FFFFFF;
        }


        &.subscription-topic {
          background: linear-gradient(44deg, #FE7E7E 0%, #F94D67 100%);
          @include ElementHover('', linear-gradient(44deg, #F94D67 0%, #FE7E7E 100%));

          .icon-sub {
            display: inline-block;
            font-size: 14px;
            color: #FFFFFF;
            margin-right: 6px;
          }

          .txt-subscription {
            font-size: 12px;
            color: #FFFFFF;
            line-height: 16px;
          }

        }

        &.no-subscription-topic {
          background: #FFFFFF;
          border: 1px solid #ECEFF6;

          @include ElementHover('', #F7F9FD);

          &:after {
            background: rgba(66, 72, 102, 0.15);
          }

          .txt-subscription {
            color: #7A7E93;
            font-size: 12px;
          }

          .icon_subscription {
            @include BgImage(14px, 14px, 'topic/index/icon_subscription.svg');
            margin-right: 6px;

          }
        }
      }
    }

  }
}

.ct-pagination {
  margin: 16px 0 64px;
}
</style>


<!--
chaopx.com/list/{pinyin}-{home_keyword_id}-{layout}-{time_filter}-{module}-{scene}-{desc}-{page}.html
-->
